export const getSiteName = (state) => state.persistStore.settings.SiteName || 'QS-Portal';